import React from "react";
import SectionHead from "./SectionHead";

const GoldenRow = ({
  label,
  tone,
  children,
}: {
  label: string;
  tone: string;
  children: React.ReactNode;
}) => (
  <div className={`gc-row ${tone}`}>
    <span className="gc-label">{label}</span>
    <p>{children}</p>
  </div>
);

const GoldenCircle = () => (
  <section className="golden" aria-labelledby="golden-title">
    <div className="wrap">
      <SectionHead
        number="01"
        title="So what is this,"
        emphasis="exactly?"
        id="golden-title"
      />
      <div className="golden-grid">
        <div className="golden-svg-wrap" aria-hidden="true">
          <svg viewBox="0 0 400 400" role="img">
            <title>The 42courses Golden Circle: Why, How, What</title>
            <circle cx="206" cy="206" r="180" fill="#2E2437" opacity="0.08" />
            <circle
              cx="200"
              cy="200"
              r="180"
              fill="#E8DCC4"
              stroke="#2E2437"
              strokeWidth="2.5"
            />
            <circle
              cx="200"
              cy="200"
              r="120"
              fill="#F5F0E1"
              stroke="#2E2437"
              strokeWidth="2.5"
            />
            <circle
              cx="200"
              cy="200"
              r="60"
              fill="#233dff"
              stroke="#2E2437"
              strokeWidth="2.5"
            />
            <text x="200" y="54" textAnchor="middle">
              WHAT
            </text>
            <text x="200" y="114" textAnchor="middle">
              HOW
            </text>
            <text x="200" y="210" textAnchor="middle" className="why-text">
              WHY
            </text>
          </svg>
          <p className="golden-caption">With a nod to Simon Sinek.</p>
        </div>
        <div>
          <GoldenRow label="Why" tone="why">
            In a world where the answer is always a click away, asking{" "}
            <strong>a better question</strong> is the most valuable skill there
            is.
          </GoldenRow>
          <GoldenRow label="How" tone="how">
            Taught by people doing the job. Short lessons. Personalised to you.
            Marked by humans.
          </GoldenRow>
          <GoldenRow label="What" tone="what">
            40+ CPD-accredited Mini MBAs. The skills school forgot.
          </GoldenRow>
        </div>
      </div>
    </div>
  </section>
);

export default GoldenCircle;
